export const users = [
  {
    username: "admin",
    password: "admin"
  },
  {
    username: "employee",
    password: "employee"
  }
];
